export enum SignUpView {
    SelectMethod,
    AssistedMethod,
    SelfSignUpMethod,
}